import { render, staticRenderFns } from "./EditUserProfile.vue?vue&type=template&id=a962a5b0&"
import script from "./EditUserProfile.vue?vue&type=script&lang=js&"
export * from "./EditUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditUserProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports